
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"layer.dropdown.title":"Mehr ...","layer.dropdown.label":"Mehr","layer.itemSelected_one":"{{count}} Objekt ausgewählt","layer.itemSelected_other":"{{count}} Objekte ausgewählt"},"en":{"layer.dropdown.title":"More ...","layer.dropdown.label":"More","layer.itemSelected_one":"{{count}} object selected","layer.itemSelected_other":"{{count}} objects selected"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();